// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";
// Models

// Dto
import { DeclarationDTO } from "Globals/Models/DTO/DeclarationDTO";

export class DeclarationModel extends ModelBase<DeclarationModel, DeclarationDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public signature: string = "";
    @MobX.observable public signedDate: Date | null = null;
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public canContact: boolean = false;
    @MobX.observable public contactByEmail: boolean = false;
    @MobX.observable public contactByPhone: boolean = false;
    @MobX.observable public contactBySms: boolean = false;
    @MobX.observable public contactByPost: boolean = false;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: DeclarationDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.signature = model.signature;
            this.signedDate = model.signedDate;
            this.createdDate = model.createdDate;
            this.canContact = model.canContact;
            this.contactByEmail = model.contactByEmail;
            this.contactByPhone = model.contactByPhone;
            this.contactBySms = model.contactBySms;
            this.contactByPost = model.contactByPost;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): DeclarationDTO => {
        let model: DeclarationDTO = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            signature: this.signature,
            signedDate: this.signedDate,
            createdDate: this.createdDate,
            canContact: this.canContact,
            contactByEmail: this.contactByEmail,
            contactByPhone: this.contactByPhone,
            contactBySms: this.contactBySms,
            contactByPost: this.contactByPost,
            isDeleted: this.isDeleted,
        };
        return model;
    };
}
